import { useQuery } from "@tanstack/react-query";
import { ETypeClient } from "../../interfaces/IQuery";
import { api } from "../../api";

interface IUserFilter {
  type: ETypeClient;
  value: string;
}

interface IResponseUserFilter {
  id: number;
  name: string;
  email: string;
  document_nr: string;
}

export interface ISelectItem {
  value: string;
  label: string;
}

export const getUserFilter = async (
  { type, value }: IUserFilter,
  signal?: AbortSignal
) => {
  let params = new URLSearchParams();

  if (!!value) params.append(type, value);
  const { data } = await api.get<IResponseUserFilter[]>("/web/user/filter", {
    params,
    signal,
  });

  if (data.length === 0) return [] as ISelectItem[];
  if (type === ETypeClient.document_nr) {
    return data.map((d) => ({ label: d.document_nr, value: d.id }));
  }
  if (type === ETypeClient.email) {
    return data.map((d) => ({ label: d.email, value: d.id }));
  }
  if (type === ETypeClient.name) {
    return data.map((d) => ({ label: d.name, value: d.id }));
  }
};

export const useUserFilter = (params: IUserFilter) => {
  const { type, value } = params;
  return useQuery(
    ["filterClient", type, value],
    ({ signal }) => getUserFilter(params, signal),
    {
      enabled: !!value && value.length >= 3,
      retry: false,
    }
  );
};
